import { render, staticRenderFns } from "./ProductNotified.vue?vue&type=template&id=c37796d6&scoped=true"
import script from "./ProductNotified.vue?vue&type=script&lang=js"
export * from "./ProductNotified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37796d6",
  null
  
)

export default component.exports